import i18n from "../../../locale/i18n";

/**
 * Format currency value for currently selected language
 */
export function formatCurrency(value: number | string) {

    if(value == null) {
        return "";
    }

    if (typeof value === 'string') {
        value = +value;
    }
    return value.toLocaleString(i18n.language, {minimumFractionDigits: 2});
}

export function formatCurrencyFourDigits(value: number | string) {

    if(value == null) {
        return "";
    }

    if (typeof value === 'string') {
        value = +value;
    }
    return value.toLocaleString(i18n.language, {maximumFractionDigits: 4, minimumFractionDigits: 4});
}